// Hover tooltip (mouse) / tap chip (touch) for one tile. Visual only: screen readers get the
// live-region summary, so this is aria-hidden. Fog tiles show only "Unexplored".

import type { CanvasSize } from './minimapViewport.js';

export interface MinimapTooltipProps {
  readonly lines: readonly string[];
  readonly x: number;
  readonly y: number;
  readonly size: CanvasSize;
  readonly touch: boolean;
}

const W = 150;
const H = 64;

export function tooltipPosition(
  x: number,
  y: number,
  size: CanvasSize,
  touch: boolean,
): { left: number; top: number } {
  if (touch) return { left: 6, top: 6 };
  const left = x + 12 + W > size.width ? Math.max(2, x - 12 - W) : x + 12;
  const top = y + 14 + H > size.height ? Math.max(2, y - 14 - H) : y + 14;
  return { left, top };
}

export function MinimapTooltip({ lines, x, y, size, touch }: MinimapTooltipProps) {
  const { left, top } = tooltipPosition(x, y, size, touch);
  const [head, ...rest] = lines;
  return (
    <div
      aria-hidden="true"
      data-testid="minimap-tooltip"
      data-appdom-id="minimap-tooltip"
      data-appdom-type="Tooltip"
      data-appdom-scope="aside"
      data-appdom-label="Tile"
      className="pointer-events-none absolute z-20 max-w-[150px] rounded border border-border/70 bg-popover/95 px-2 py-1 text-[11px] leading-snug text-popover-foreground shadow-md"
      style={{ left, top }}
    >
      <div className="font-semibold tabular-nums">{head}</div>
      {rest.map((l) => (
        <div key={l} className="text-muted-foreground">
          {l}
        </div>
      ))}
    </div>
  );
}
